import { c as _c } from "react/compiler-runtime";
import React from 'react';
import usePDPProductLabel from 'data-hooks/usePDPProductLabel';
import PDPGalleryLabelsUI from './PDPGalleryLabelsUI';
const PDPGalleryLabels = () => {
  const $ = _c(5);
  const {
    loading,
    error,
    data: t0
  } = usePDPProductLabel();
  const {
    productLabel
  } = t0;
  if (error) {
    return null;
  }
  let t1;
  if ($[0] !== productLabel) {
    t1 = productLabel ? [productLabel] : [];
    $[0] = productLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== loading || $[3] !== t1) {
    t2 = <PDPGalleryLabelsUI loading={loading} labels={t1} />;
    $[2] = loading;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default PDPGalleryLabels;